export default function formatEmail(email){
    this.email = email.toLowerCase();
}